import { FC, useMemo, memo } from 'react'
import dynamic from 'next/dynamic'
import clsx from 'clsx'

import Auth from 'store/auth'
const YoutubeTranslation = dynamic(
  () => import('../player/translation/youtube-translation/youtube-translation'),
  { ssr: false }
)
const NotFilledBanner = dynamic(
  () => import('components/banners/not-filled-banner/not-filled-banner')
)
// import WebinarActiveEnd from '../webinar-active-end/webinar-active-end' // Вернуть когда закончится курс "Современная гериатрия для практикующих врачей".
import WebinarActiveEndAdvertising from '../webinar-active-end-advertising/webinar-active-end-advertising'
import { popupName } from 'constants/auth/auth-data'
import { checkVkLink } from 'utils/vk/vkVideoUtils'
import VkTranslation from '../player/translation/vk-translation/vk-translation'
import { checkRutubeLink } from 'utils/rutube/rutubeVideoUtils'
import RutubeTranslation from '../player/translation/rutube-translation/rutube-translation'
import { checkYaVideoLink } from 'utils/yandex/yaVideoUtils'
import YandexTranslation from '../player/translation/yandex-translation/yandex-translation'
const BannerAuthDopInfo = dynamic(
  () => import('components/banners/banner-auth-dopinfo/banner-auth-dopinfo')
)

const NotAvaliable = dynamic(
  () => import('components/banners/banner-not-avaliable/banner-not-avaliable')
)

import { PLACEFLAG_LIVE } from 'constants/analytic-data'
import { IMaterial } from 'constants/types/webinar.types'
import styles from './translation-selector.module.scss'

interface IWebinar {
  isEnded: boolean
  dataset: IMaterial
  isForStudents: boolean
}

const TranslationSelector: FC<IWebinar> = ({ dataset, isEnded, isForStudents }: IWebinar) => {
  const { isFilledUser, isSponsor, isNotAuthorized, isLoaded } = Auth.useAuth()
  const getCurrentPlayer = () => {
    if (checkVkLink(dataset.videoLink)) return <VkTranslation videoLink={dataset.videoLink} />

    if (checkRutubeLink(dataset.videoLink))
      return <RutubeTranslation videoLink={dataset.videoLink} />

    if (checkYaVideoLink(dataset.videoLink))
      return <YandexTranslation videoLink={dataset.videoLink} />

    return null
  }

  const translationContent = useMemo(() => {
    if (!isLoaded) {
      return null
    } else if (isNotAuthorized && !dataset.unregisteredAvailable) {
      return (
        <div className={clsx(styles.unregistered, styles.events)}>
          <NotAvaliable modificator="MATERIALS" />
        </div>
      )
    } else if (isNotAuthorized) {
      return (
        <div className={styles.events}>
          <NotFilledBanner
            isNoMargin
            isVertical
            placeFlag={PLACEFLAG_LIVE}
            link={popupName.registration}
            buttonText={'Зарегистрироваться'}
          >
            Для просмотра вебинаров вам необходимо войти или зарегистрироваться
          </NotFilledBanner>
        </div>
      )
    } else if (!isFilledUser && !isSponsor && !isForStudents) {
      return (
        <div className={styles.events}>
          <div className={styles.dopinfoBanner}>
            <BannerAuthDopInfo />
          </div>
        </div>
      )
    } else if (isEnded) {
      return (
        <div className={styles.events}>
          {/* <WebinarActiveEnd webinarId={dataset.id} /> // Вернуть когда закончится курс "Современная гериатрия для практикующих врачей". */}

          <WebinarActiveEndAdvertising webinarId={dataset.id} />
        </div>
      )
    } else
      return (
        <div className={styles.events}>
          {getCurrentPlayer() || <YoutubeTranslation videoId={dataset.videoLink} />}
        </div>
      )
  }, [isFilledUser, isEnded, dataset, isSponsor, isForStudents, isLoaded])

  return translationContent
}

export default memo(TranslationSelector)
